export const delet = {
    height: '40px',
    padding: '5px 20px',
    borderRadius: '8px',
    background: '#E87819',
    color: '#fff',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px', /* 18.2px */
    overflow: 'hidden',
    fontFamily: 'DM Sans',
    "&:hover": {
        background: '#F0142F'
    },
    marginLeft: '10px'
}
export const cancle = {
    width: 'fit-content',
    height: '40px',
    padding: '11px 20px',
    borderRadius: '8px',
    background: '#FFF',
    color: '#1D1F2C',
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '20px', /* 18.2px */
    overflow: 'hidden',
    fontFamily: 'Public Sans',
    border: '1px solid #C2C6CE',
    "&:hover": {
        background: '#E87819',
        color: '#fff'
    },
}